import { ComponentsOverrides, ComponentsProps, Theme } from '@mui/material';

export const MuiFormControlLabel: {
    styleOverrides: ComponentsOverrides<Theme>['MuiFormControlLabel'];
    defaultProps?: ComponentsProps['MuiFormControlLabel'];
} = {
    styleOverrides: {
        root: ({ theme }) => ({
            gap: theme.spacing(),
        }),
    },
};
